import {
  MessageOutlined,
  BarsOutlined,
  ProfileOutlined,
  CreditCardOutlined,
} from "@ant-design/icons-vue";
import RadioButtonIcon from "@/app/shared/components/icons/RadioButtonIcon.vue";
import { ChannelType } from "@/app/shared/utils/enums";

export const TemplateTabsKey = Object.freeze({
  BuildChatbot: 1,
  GeneralData: 2,
  AttentionTime: 3,
  LinkedChannels: 4,
  WaitTimeout: 5,
});

export const BotActions = Object.freeze({
  AddMessage: 1,
  ContinueToOptions: 2,
  TransferToQueue: 3,
  FinishChatbot: 4,
  BackToPreviousMenu: 5,
  ContinueToButtons: 6,
  ContinueToList: 7,
  ContinueToCard: 8,
  ContinueConnectorApi: 9,
});

export const BotType = Object.freeze({
  MonoChannel: 1,
  MultiChannel: 2,
});

export const NodeType = Object.freeze({
  Message: 1,
  Options: 2,
  SingleOption: 3,
  Buttons: 4,
  ButtonOption: 5,
  List: 6,
  ListSection: 7,
  ListSectionItem: 8,
  Card: 9,
  CardSection: 10,
  MessageWithImage: 11,
  MessageWithDocument: 12,
  MessageWithVideo: 13,
  WrongOptionAPI: 14,
  OptionConsultApi: 15,
});

export const NodeTypeTextSize = {
  [NodeType.Message]: {
    'message': 1000,
  },
  [NodeType.Options]: {
    'message': 1000,
    'message_wrong_answer': 350,
  },
  [NodeType.SingleOption]: {
    'description': 40,
    'message': 350,
    'transfer_queue_message': 350,
  },
  [NodeType.Buttons]: {
    'message': 1000,
    'message_wrong_answer': 350,
  },
  [NodeType.ButtonOption]: {
    'title': 20,
    'message': 350,
    'transfer_queue_message': 350,
  },
  [NodeType.List]: {
    'title': 60,
    'message': 1000,
    'title_button': 20,
    'message_wrong_answer': 350,
  },
  [NodeType.ListSection]: {
    'title': 24,
  },
  [NodeType.ListSectionItem]: {
    'title': 24,
    'description': 72,
    'message': 350,
    'transfer_queue_message': 350,
  },
  [NodeType.Card]: {
    'message_wrong_answer': 350,
    'message': 80,
  },
  [NodeType.CardSection]: {
    'title': 80,
    'message': 80,
  },
  [NodeType.MessageWithImage]: {
    'message': 1000,
  },
  [NodeType.MessageWithDocument]: {
    'message': 1000,
  },
  [NodeType.MessageWithVideo]: {
    'message': 1000,
  },
}

export const hasSimpleOptionConfig = [
  NodeType.SingleOption,
  NodeType.ButtonOption,
  NodeType.ListSectionItem,
  // NodeType.OptionConsultApi,
  // NodeType.WrongOptionAPI,
];

export const hasConnectorOptionConfig = [
  // NodeType.OptionConsultApi,
  // NodeType.WrongOptionAPI,
];

// Usado para crear nuevos nodos
export const NodeData = {
  [NodeType.Message]: {
    name: "nuevo mensaje",
    icon: MessageOutlined,
  },
  [NodeType.Options]: {
    name: "opciones múltiples",
    icon: ProfileOutlined,
  },
  [NodeType.Buttons]: {
    name: "botones",
    icon: RadioButtonIcon,
  },
  [NodeType.List]: {
    name: "lista",
    icon: BarsOutlined,
  },
  [NodeType.Card]: {
    name: "tarjetas",
    icon: CreditCardOutlined,
  },
};

export const ChildNodeType = {
  [NodeType.Options]: NodeType.SingleOption,
  [NodeType.Buttons]: NodeType.ButtonOption,
  [NodeType.List]: NodeType.ListSection,
  [NodeType.ListSection]: NodeType.ListSectionItem,
  [NodeType.Card]: NodeType.CardSection,
  [NodeType.CardSection]: NodeType.ButtonOption,
  // [NodeType.OptionConsultApi]: NodeType.OptionConsultApi,
  // [NodeType.WrongOptionAPI]: NodeType.WrongOptionAPI,
};

export const DefaultNodeBodies = Object.freeze({
  [NodeType.Message]: {
    message: "Hola, ¿En qué podemos ayudarte?",
    type: NodeType.Message,
    action: BotActions.FinishChatbot,
    order: 1,
  },
  [NodeType.Options]: {
    message: "Hola, ¿En qué podemos ayudarte?",
    type: NodeType.Options,
    message_wrong_answer: "Disculpa, no he entendido tu respuesta. Escribe nuevamente",
    order: 1,
  },
  [NodeType.SingleOption]: {
    order: 1,
    message: "Actualmente no atendemos por este medio, gracias",
    description: "Una opción",
    type: NodeType.SingleOption,
    action: BotActions.FinishChatbot,
  },
  [NodeType.Buttons]: {
    message: "Selecciona una de nuestras opciones",
    type: NodeType.Buttons,
    message_wrong_answer:
      "Disculpa, no he entendido tu respuesta. Por favor, haz click en una de las opciones brindadas",
    order: 1,
  },
  [NodeType.ButtonOption]: {
    order: 1,
    message: "Actualmente no atendemos por este medio, gracias.",
    title: "Botón 1",
    type: NodeType.ButtonOption,
    action: BotActions.FinishChatbot,
  },
  [NodeType.List]: {
    title: "Lista de...",
    message: "Selecciona una de nuestras opciones",
    title_button: "Menú",
    type: NodeType.List,
    message_wrong_answer:
      "Disculpa, no he entendido tu respuesta. Por favor, haz click en una de las opciones brindadas.",
    order: 1,
  },
  [NodeType.ListSection]: {
    order: 1,
    title: "Selecciona",
    type: NodeType.ListSection,
  },
  [NodeType.ListSectionItem]: {
    order: 1,
    message: "Actualmente no atendemos por este medio, gracias.",
    title: "Item 1",
    type: NodeType.ListSectionItem,
    action: BotActions.FinishChatbot,
  },
  [NodeType.Card]: {
    order: 1,
    type: NodeType.Card,
    message_wrong_answer:
      "Disculpa, no he entendido tu respuesta. Por favor, haz click en una de las opciones brindadas.",
  },
  [NodeType.CardSection]: {
    order: 1,
    type: NodeType.CardSection,
    message: "¡Hola! Selecciona una de las opciones.",
    title: "Tarjeta 1",
  },
  [NodeType.OptionConsultApi]: {
    type: NodeType.OptionConsultApi,
    action: BotActions.FinishChatbot,
  },
  [NodeType.WrongOptionAPI]: {
    order: 99,
    type: NodeType.WrongOptionAPI,
    action: BotActions.FinishChatbot,
    description: 'Error en respuesta de API',
  },
});

export const ChatbotStatus = Object.freeze({
  Active: 1,
  Inactive: 2,
});

export const StatusProps = Object.freeze({
  [ChatbotStatus.Active]: { color: "green", text: "Activo" },
  [ChatbotStatus.Inactive]: { color: "default", text: "Inactivo" },
});

export const PREFIX_VARS = "#";

export const ChannelsIvrConnector = [
  ChannelType.Whatsapp,
]